/* ==========================================================================
   LoadingInformationRxjs > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'LoadingInformationRxjs',
    init: true,
    css: {
        image: 'm-loading-information__image'
    },
    image: {
        src: '/comun/images/shim.gif',
        resize: {
            height: 220,
            width: 450,
            quality: 97
        }
    }
};

module.exports = () => config;
